<template>
	<!-- Keeping for future use -->
	<!-- <v-tooltip v-model="show" v-if="tooltip" :disabled="!(tooltip && summary)" location="top">
		<template #activator="{ props: tooltipProps }">
			<div v-bind="tooltipProps">
				<MultiSelectMenuContent
					:label="label"
					:options="options"
					:model-value="modelValue"
					@update:modelValue="$emit('update:modelValue', $event)"
					@apply="$emit('apply', $event)"
					@open="show = false"
				/>
			</div>
		</template>
		<span style="white-space: pre-line">
			{{ summary }}
		</span>
	</v-tooltip> -->

	<MultiSelectMenuContent
		:label="label"
		:options="options"
		:model-value="modelValue"
		:tooltip="tooltip"
		@update:modelValue="$emit('update:modelValue', $event)"
		@apply="$emit('apply', $event)"
	/>
</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from 'vue';
import MultiSelectMenuContent from './MultiSelectMenuContent.vue';
import { FilterOption, FilterValue } from '@/rennovation/planning-view/types/components/types';

const props = defineProps<{
	label?: string;
	options: FilterOption[];
	modelValue: FilterValue;
	tooltip?: boolean;
}>();
const emit = defineEmits<{
	'update:modelValue': [value: FilterValue];
	apply: [value: FilterValue];
}>();

// const show = ref(false);

// const summary = computed(() => {
// 	const labels = props.modelValue.selected.map((item) => item.label);

// 	return labels.join('\n');
// });
</script>
